<div class="nav-wrapper">
    <nav class="main-nav" aria-label="Menú principal">
        <ul class="nav-list">
            <!-- Home -->
            <li class="nav-item">
                <a routerLink="/" class="nav-link home-link" aria-label="Inicio">
                    <svg viewBox="0 0 24 24" class="icon-home">
                        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                </a>
            </li>

            <!-- Web Hosting Pro -->
            <li class="nav-item has-dropdown theme-blue" (mouseenter)="openMenu('webHostingPro')"
                (mouseleave)="closeMenu()">
                <a routerLink="/web-hosting" class="nav-link"
                    [class.hover-active]="activeMenu === 'webHostingPro'">
                    Web Hosting Pro
                </a>

                <!-- Dropdown Content -->
                <div class="dropdown-content cols-2" *ngIf="activeMenu === 'webHostingPro'">
                    <div class="col col--menu-text-wide">
                        <div class="group">
                            <div class="group-title">Web Hosting Pro</div>
                            <ul class="sub-menu">
                                <li>
                                    <a routerLink="/web-hosting">
                                        <span class="title">Web Hosting Pro</span>
                                        <span class="desc">Precios Bajos con Altos beneficios</span>
                                    </a>
                                </li>
                                <li>
                                    <a routerLink="/hosting-reseller">
                                        <span class="title">Hosting Reseller</span>
                                        <span class="desc">Crea tu propio negocio a una bajo costo, se revendedor de
                                            hosting</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="group mt-3">
                            <div class="group-title">Dominio</div>
                            <ul class="sub-menu">
                                <li>
                                    <a [href]="cart.buildCommercialDomainUrl('register')" target="_blank" rel="noopener noreferrer">
                                        <span class="title">Registro de dominio</span>
                                        <span class="desc">Registra tu dominio .com .net .org .info .name .us
                                            .biz</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="cart.buildCommercialDomainUrl('transfer')" target="_blank" rel="noopener noreferrer">
                                        <span class="title">Transferencia de Dominio</span>
                                        <span class="desc">Si tienes regitrado tu dominio con otro proveedor, no hay
                                            problema nosotros lo transferimos</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col menu-promo-col menu-promo-col--hosting" *ngIf="domainComOfferPrice != null">
                        <a
                            [href]="cart.buildCommercialDomainUrl('register')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="menu-hosting-offer"
                            (click)="closeMenu()">
                            <span class="menu-hosting-offer__shine" aria-hidden="true"></span>
                            <div class="menu-hosting-offer__head">
                                <span class="menu-hosting-offer__label">Oferta</span>
                                <span class="menu-hosting-offer__bang" aria-hidden="true">!</span>
                            </div>
                            <span class="menu-hosting-offer__product">Dominio .com</span>
                            <div class="menu-hosting-offer__price-row">
                                <div class="menu-hosting-offer__price-block">
                                    <span class="menu-hosting-offer__symbol">{{ cart.symbol }}</span>
                                    <span class="menu-hosting-offer__amount">{{ domainComOfferPrice | rackeoCurrency }}</span>
                                </div>
                                <span class="menu-hosting-offer__per">registro</span>
                            </div>
                            <span class="menu-hosting-offer__fineprint">Precio registro .com<span *ngIf="cart.currencyHint"> · {{ cart.currencyHint }}</span></span>
                        </a>
                    </div>
                </div>
            </li>

            <!-- Web Hosting Pyme -->
            <li class="nav-item nav-item--standalone">
                <a routerLink="/web-hosting-pyme" class="nav-link">
                    Web Hosting Pyme
                </a>
            </li>

            <!-- Virtualización -->
            <li class="nav-item has-dropdown theme-orange" (mouseenter)="openMenu('virtualizacion')"
                (mouseleave)="closeMenu()">
                <a routerLink="/virtualizacion" class="nav-link"
                    [class.hover-active]="activeMenu === 'virtualizacion'">
                    Virtualización
                </a>

                <div class="dropdown-content cols-2 theme-orange" *ngIf="activeMenu === 'virtualizacion'">
                    <div class="col col--menu-text-wide">
                        <div class="group">
                            <div class="group-title theme-orange">Virtualizacion</div>
                            <ul class="sub-menu">
                                <li>
                                    <a routerLink="/virtualizacion">
                                        <span class="title">Virtualizacion Linux</span>
                                        <span class="desc">VPS tenemos los precios más bajo del mercado
                                            compruebalo</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col menu-promo-col menu-promo-col--vps" *ngIf="vpsSsd1Monthly != null">
                        <a routerLink="/virtualizacion" class="menu-vps-offer" (click)="closeMenu()">
                            <span class="menu-vps-offer__shine" aria-hidden="true"></span>
                            <span class="menu-vps-offer__label">Oferta</span>
                            <span class="menu-vps-offer__product">VPS Cloud SSD</span>
                            <div class="menu-vps-offer__price-line">
                                <span class="menu-vps-offer__money">
                                    <span class="menu-vps-offer__symbol">{{ cart.symbol }}</span>
                                    <span class="menu-vps-offer__amount">{{ vpsSsd1Monthly | rackeoCurrency }}</span>
                                </span>
                                <span class="menu-vps-offer__per">x mes</span>
                            </div>
                            <span class="menu-vps-offer__fineprint" *ngIf="cart.currencyHint">{{ cart.currencyHint }} · plan SSD1</span>
                            <span class="menu-vps-offer__fineprint" *ngIf="!cart.currencyHint">Plan SSD1 · precio mensual</span>
                        </a>
                    </div>
                </div>
            </li>

            <!-- Servidores Dedicados -->
            <li class="nav-item has-dropdown theme-green" (mouseenter)="openMenu('servidoresDedicados')"
                (mouseleave)="closeMenu()">
                <a routerLink="/servidores-dedicados" class="nav-link"
                    [class.hover-active]="activeMenu === 'servidoresDedicados'">
                    Servidores Dedicados
                </a>

                <div class="dropdown-content cols-2 theme-green right-aligned"
                    *ngIf="activeMenu === 'servidoresDedicados'">
                    <div class="col col--menu-text-wide">
                        <div class="group">
                            <div class="group-title theme-green">Servidores Dedicados</div>
                            <ul class="sub-menu">
                                <li>
                                    <a routerLink="/servidores-dedicados">
                                        <span class="title">Servidores Dedicados</span>
                                        <span class="desc">Elige tu servidor personalizado como tu quieras</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col menu-promo-col menu-promo-col--dedicados">
                        <a routerLink="/servidores-dedicados" class="menu-dedicados-offer" (click)="closeMenu()">
                            <span class="menu-dedicados-offer__shine" aria-hidden="true"></span>
                            <div class="menu-dedicados-offer__head">
                                <span class="menu-dedicados-offer__label">Gratis</span>
                                <span class="menu-dedicados-offer__bang" aria-hidden="true">!</span>
                            </div>
                            <span class="menu-dedicados-offer__subtitle">Setup inicial</span>
                            <p class="menu-dedicados-offer__fineprint">Por la compra de tu plan</p>
                        </a>
                    </div>
                </div>
            </li>

            <!-- Área Cliente -->
            <li class="nav-item has-dropdown theme-dark" (mouseenter)="openMenu('areaCliente')"
                (mouseleave)="closeMenu()">
                <a [href]="URL.RACKEO_LOGIN" class="nav-link"
                    [class.hover-active]="activeMenu === 'areaCliente'">
                    Área Cliente
                </a>

                <div class="dropdown-content cols-3 right-aligned theme-dark" *ngIf="activeMenu === 'areaCliente'">
                    <div class="col">
                        <div class="group">
                            <div class="group-title theme-dark">Ventas</div>
                            <ul class="sub-menu">
                                <li>
                                    <a [href]="URL.SUPPORT">
                                        <span class="title">Cotizaciones</span>
                                        <span class="desc">Cotiza y compara</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.SUPPORT">
                                        <span class="title">Ventas</span>
                                        <span class="desc">¿Necesitas orientación en tu compra?</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="group mt-3" *ngIf="site.isChile">
                            <div class="group-title theme-dark">Pagos</div>
                            <ul class="sub-menu">
                                <li>
                                    <a routerLink="/paga-deuda">
                                        <span class="title">Pago de cuentas</span>
                                        <span class="desc">Aquí paga las deudas de tu servicio</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.RACKEO_INVOICE_REQUEST" target="_blank" rel="noopener noreferrer">
                                        <span class="title">Solicitar factura</span>
                                        <span class="desc">Solicita tu factura fácilmente</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col">
                        <div class="group">
                            <div class="group-title theme-dark">Soporte</div>
                            <ul class="sub-menu">
                                <li>
                                    <a [href]="URL.RACKEO_LOGIN">
                                        <span class="title">Área Cliente</span>
                                        <span class="desc">Ingresa a revisar los detalles de cuenta</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.RACKEO_YOUTUBE" target="_blank">
                                        <span class="title">Videos tutoriales</span>
                                        <span class="desc">Revisa los videos tutoriales</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.RACKEO_DOCS" target="_blank">
                                        <span class="title">Ayuda y tutoriales</span>
                                        <span class="desc">Portal de ayuda</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.SUPPORT_SUGGESTIONS" target="_blank">
                                        <span class="title">Reclamos</span>
                                        <span class="desc">Que nuestros clientes se sientan satisfechos</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.RACKEO_STATUS" target="_blank" rel="noopener noreferrer">
                                        <span class="title">Estado de Servidores</span>
                                        <span class="desc">Revisa el estado en tiempo real</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col">
                        <div class="group">
                            <div class="group-title theme-dark">Empresa</div>
                            <ul class="sub-menu">
                                <li>
                                    <a routerLink="/empresa/nosotros">
                                        <span class="title">Nosotros</span>
                                        <span class="desc">Conócenos</span>
                                    </a>
                                </li>
                                <li>
                                    <a routerLink="/empresa/data-center">
                                        <span class="title">Nuestro Data</span>
                                        <span class="desc">Infraestructura</span>
                                    </a>
                                </li>
                                <li>
                                    <a routerLink="/empresa/formas-pago">
                                        <span class="title">Formas de Pago</span>
                                        <span class="desc">Fácil y rápido</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.HAULMER_LEGAL_WEB_HOSTING">
                                        <span class="title">Términos y Condiciones</span>
                                        <span class="desc">Adecuado uso</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.SUPPORT_SUGGESTIONS">
                                        <span class="title">Reclamos</span>
                                        <span class="desc">Tú eres importante</span>
                                    </a>
                                </li>
                                <li>
                                    <a [href]="URL.HAULMER_BLOG">
                                        <span class="title">Blog</span>
                                        <span class="desc">Datos Interesantes</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </nav>

    <!-- Botón Responsive -->
    <button
        class="nav-hamburger"
        [class.is-open]="isMobileMenuOpen"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen"
        aria-label="Abrir menú de navegación">
        <span></span>
        <span></span>
        <span></span>
    </button>

    <!-- Backdrop oscuro -->
    <div class="mobile-nav-backdrop" [class.is-open]="isMobileMenuOpen" (click)="closeMobileMenu()" (keydown.escape)="closeMobileMenu()" aria-hidden="true"></div>

    <!-- Drawer de navegación móvil -->
    <nav class="mobile-nav" [class.is-open]="isMobileMenuOpen" aria-label="Menú móvil">
        <div class="mobile-nav__header">
            <span class="mobile-nav__title">Menú</span>
            <button class="mobile-nav__close" (click)="closeMobileMenu()" aria-label="Cerrar menú">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
            </button>
        </div>

        <ul class="mobile-nav-list">
            <!-- Inicio -->
            <li class="mobile-nav-item">
                <a routerLink="/" class="mobile-nav-link" (click)="closeMobileMenu()">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                    </svg>
                    Inicio
                </a>
            </li>

            <!-- Web Hosting Pro -->
            <li class="mobile-nav-item mobile-nav-item--accordion">
                <button
                    class="mobile-nav-link mobile-nav-link--parent"
                    (click)="toggleAccordion('webHostingPro')"
                    [class.is-open]="activeAccordion === 'webHostingPro'"
                    [attr.aria-expanded]="activeAccordion === 'webHostingPro'">
                    <span>Web Hosting Pro</span>
                    <svg class="mobile-nav-chevron" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M7 10l5 5 5-5z"/>
                    </svg>
                </button>
                <ul class="mobile-sub-list" [class.is-open]="activeAccordion === 'webHostingPro'">
                    <li><a routerLink="/web-hosting" (click)="closeMobileMenu()">Web Hosting Pro</a></li>
                    <li><a routerLink="/hosting-reseller" (click)="closeMobileMenu()">Hosting Reseller</a></li>
                    <li><a [href]="cart.buildCommercialDomainUrl('register')" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Registro de Dominio</a></li>
                    <li><a [href]="cart.buildCommercialDomainUrl('transfer')" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Transferencia de Dominio</a></li>
                </ul>
            </li>

            <!-- Web Hosting Pyme -->
            <li class="mobile-nav-item">
                <a routerLink="/web-hosting-pyme" class="mobile-nav-link" (click)="closeMobileMenu()">Web Hosting Pyme</a>
            </li>

            <!-- Virtualización -->
            <li class="mobile-nav-item mobile-nav-item--accordion">
                <button
                    class="mobile-nav-link mobile-nav-link--parent"
                    (click)="toggleAccordion('virtualizacion')"
                    [class.is-open]="activeAccordion === 'virtualizacion'"
                    [attr.aria-expanded]="activeAccordion === 'virtualizacion'">
                    <span>Virtualización</span>
                    <svg class="mobile-nav-chevron" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M7 10l5 5 5-5z"/>
                    </svg>
                </button>
                <ul class="mobile-sub-list" [class.is-open]="activeAccordion === 'virtualizacion'">
                    <li><a routerLink="/virtualizacion" (click)="closeMobileMenu()">Virtualización Linux (VPS)</a></li>
                </ul>
            </li>

            <!-- Servidores Dedicados -->
            <li class="mobile-nav-item mobile-nav-item--accordion">
                <button
                    class="mobile-nav-link mobile-nav-link--parent"
                    (click)="toggleAccordion('servidoresDedicados')"
                    [class.is-open]="activeAccordion === 'servidoresDedicados'"
                    [attr.aria-expanded]="activeAccordion === 'servidoresDedicados'">
                    <span>Servidores Dedicados</span>
                    <svg class="mobile-nav-chevron" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M7 10l5 5 5-5z"/>
                    </svg>
                </button>
                <ul class="mobile-sub-list" [class.is-open]="activeAccordion === 'servidoresDedicados'">
                    <li><a routerLink="/servidores-dedicados" (click)="closeMobileMenu()">Servidores Dedicados</a></li>
                </ul>
            </li>

            <!-- Área Cliente -->
            <li class="mobile-nav-item mobile-nav-item--accordion">
                <button
                    class="mobile-nav-link mobile-nav-link--parent"
                    (click)="toggleAccordion('areaCliente')"
                    [class.is-open]="activeAccordion === 'areaCliente'"
                    [attr.aria-expanded]="activeAccordion === 'areaCliente'">
                    <span>Área Cliente</span>
                    <svg class="mobile-nav-chevron" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                        <path d="M7 10l5 5 5-5z"/>
                    </svg>
                </button>
                <ul class="mobile-sub-list" [class.is-open]="activeAccordion === 'areaCliente'">
                    <li class="mobile-sub-list__group-label">Ventas</li>
                    <li><a [href]="URL.SUPPORT" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Cotizaciones</a></li>
                    <li><a [href]="URL.SUPPORT" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Ventas</a></li>

                    <ng-container *ngIf="site.isChile">
                        <li class="mobile-sub-list__group-label">Pagos</li>
                        <li><a routerLink="/paga-deuda" (click)="closeMobileMenu()">Pago de cuentas</a></li>
                        <li><a [href]="URL.RACKEO_INVOICE_REQUEST" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Solicitar factura</a></li>
                    </ng-container>

                    <li class="mobile-sub-list__group-label">Soporte</li>
                    <li><a [href]="URL.RACKEO_LOGIN" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Área Cliente</a></li>
                    <li><a [href]="URL.RACKEO_YOUTUBE" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Videos tutoriales</a></li>
                    <li><a [href]="URL.RACKEO_DOCS" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Ayuda y tutoriales</a></li>
                    <li><a [href]="URL.SUPPORT_SUGGESTIONS" (click)="closeMobileMenu()">Reclamos</a></li>
                    <li><a [href]="URL.RACKEO_STATUS" target="_blank" rel="noopener noreferrer" (click)="closeMobileMenu()">Estado de Servidores</a></li>

                    <li class="mobile-sub-list__group-label">Empresa</li>
                    <li><a routerLink="/empresa/nosotros" (click)="closeMobileMenu()">Nosotros</a></li>
                    <li><a routerLink="/empresa/data-center" (click)="closeMobileMenu()">Nuestro Data</a></li>
                    <li><a routerLink="/empresa/formas-pago" (click)="closeMobileMenu()">Formas de Pago</a></li>
                    <li><a [href]="URL.HAULMER_LEGAL_WEB_HOSTING" (click)="closeMobileMenu()">Términos y Condiciones</a></li>
                    <li><a [href]="URL.SUPPORT_SUGGESTIONS" (click)="closeMobileMenu()">Reclamos</a></li>
                    <li><a [href]="URL.HAULMER_BLOG" (click)="closeMobileMenu()">Blog</a></li>
                </ul>
            </li>
        </ul>
    </nav>
</div>
